import { render, staticRenderFns } from "./ComercialesViewDetalle.vue?vue&type=template&id=2cc53717&"
import script from "./ComercialesViewDetalle.vue?vue&type=script&lang=js&"
export * from "./ComercialesViewDetalle.vue?vue&type=script&lang=js&"
import style0 from "./ComercialesViewDetalle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports